/** @jsx jsx */
/** @jsxRuntime classic */
import { jsx } from '@emotion/react';
import React from 'react';
import useTheme from '../style/useTheme';
import { hex2rgba } from '../utils';

export type Props = React.PropsWithChildren<{
  id: string;
  ariaLabel?: string;
  focused?: boolean;
  checked: boolean;
  disabled?: boolean;
  onChange?: (checked: boolean) => void;
}>;

const BaseCheckbox: React.FC<Props> = ({
  id,
  ariaLabel,
  children,
  focused,
  checked,
  disabled,
  onChange,
}) => {
  const { theme, resolveColor } = useTheme();

  return (
    <div
      css={{
        flexDirection: 'row',
        display: 'flex',
        alignItems: 'center',
      }}
    >
      <input
        css={{
          minWidth: '22px',
          width: '22px',
          height: '22px',
          marginRight: '9px',
          boxShadow:
            checked || focused
              ? `inset 0 0 0 1.2px ${hex2rgba(
                  resolveColor(theme.components.radio.selected),
                  1
                )},
              inset 0 2px 4px rgb(31 38 46 / 10%)`
              : `
              inset 0 0 0 1.2px ${resolveColor(
                theme.components.radio['icon-border']
              )}, inset 0 2px 4px rgb(31 38 46 / 10%);
            `,
        }}
        aria-label={ariaLabel || id}
        id={id}
        data-testid={id}
        onClick={() => disabled || (onChange && onChange(!checked))}
        className="origami-Checkbox"
        type="checkbox"
        checked={checked}
        readOnly={!onChange}
        disabled={disabled}
      />
      {children}
    </div>
  );
};

export default BaseCheckbox;
